import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box, Avatar } from '@mui/material';

export default function CreateGroupModal({ userId, botId, open, onClose, onCreated }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [avatar, setAvatar] = useState('/assets/default-group.png'); // Дефолтная аватарка

  const handleAvatarChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => setAvatar(reader.result);
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleCreate = async () => {
    if (!name.trim()) return alert('Введите название группы');
    
    // Генерация 5-значного кода (Английский капс)
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let inviteCode = '';
    for (let i = 0; i < 5; i++) {
      inviteCode += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    
    try {
      const res = await fetch('/api/groups', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // Отправляем аватарку и сгенерированный код на бэкенд
        body: JSON.stringify({ userId, botId, name, description, avatar, inviteCode })
      });
      
      const data = await res.json();
      if (data.success) {
        onCreated(data.chatId);
      } else {
        alert(data.error || 'Ошибка');
      }
    } catch (err) {
      alert(`Ошибка: ${err.message}`);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { backgroundColor: '#1e1e1e', color: 'white', minWidth: '300px' } }}>
      <DialogTitle sx={{ textAlign: 'center' }}>Создать группу</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
        
        {/* Выбор аватарки */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, mt: 1 }}>
          <label htmlFor="group-avatar-upload">
            <Avatar src={avatar} sx={{ width: 100, height: 100, cursor: 'pointer', border: '2px solid #444' }} />
            <input id="group-avatar-upload" type="file" accept="image/*" onChange={handleAvatarChange} style={{ display: 'none' }} />
          </label>
        </Box>

        <TextField 
          fullWidth 
          label="Название группы" 
          value={name} 
          onChange={(e) => setName(e.target.value)} 
          variant="outlined"
          InputLabelProps={{ style: { color: '#aaa' } }}
          sx={{ input: { color: 'white' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }}
        />
        <TextField 
          fullWidth 
          label="Описание" 
          value={description} 
          onChange={(e) => setDescription(e.target.value)} 
          multiline 
          rows={3}
          InputLabelProps={{ style: { color: '#aaa' } }}
          sx={{ input: { color: 'white' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }}
        />
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 2 }}>
        <Button onClick={onClose} sx={{ color: '#aaa' }}>Отмена</Button>
        <Button onClick={handleCreate} variant="contained" color="secondary" sx={{ borderRadius: '20px' }}>Создать</Button>
      </DialogActions>
    </Dialog>
  );
}